module.exports = __webpack_public_path__ + "img/Base2.586fa521.svg";